import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { useQuery } from "@apollo/client";
import ApolloContext from "@tvg/utils/apolloContext";
import WagerGroupQuery from "@tvg/ipp/src/graphql/queries/wagerGroupQuery.graphql";
import { apolloOptionsGroupWagerPP } from "@tvg/ipp/src/graphql/options.graph";
import { WroWagerGroup } from "@tvg/ts-types/WroWager";
import type {
  GetGroupWagersPastPerformanceProps,
  WagerHistoryData
} from "../types";

const useGetGroupWagersPastPerformance = ({
  accountNumber,
  trackCode,
  raceNumber,
  raceDate
}: GetGroupWagersPastPerformanceProps) => {
  const { behgClient } = useContext(ApolloContext);
  const behgToggle = useSelector((store) =>
    get(store, "capi.featureToggles.tvgenablebehg", false)
  );
  const myBetsResultedBetTicket = useSelector((store) =>
    get(store, "capi.featureToggles.myBetsResultedBetTicket", false)
  );

  const { data, loading } = useQuery<WagerHistoryData>(
    WagerGroupQuery,
    apolloOptionsGroupWagerPP({
      trackCode,
      raceNumber,
      raceDate,
      accountNumber,
      behgClient,
      behgToggle,
      myBetsResultedBetTicket
    })
  );

  return useMemo(() => {
    const groupWagers: WroWagerGroup[] = get(
      data,
      "wagerHistory.groupWagers",
      []
    );

    if (loading || !groupWagers.length) {
      return [];
    }

    return groupWagers.map((groupWager) => ({
      value: groupWager.value.replace(/#/gi, "|"),
      wagers: (groupWager.wagers || []).filter(
        (wager) =>
          get(wager, "betStatus.code") !== "C" &&
          get(wager, "raceDate") === raceDate
      )
    }));
  }, [loading, data]);
};

export default useGetGroupWagersPastPerformance;
